// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"4f828214fef8d55dec5a","293":"200d3927b591bd525bbe","454":"546674553cf58fe5ef2d"}[chunkId] + ".js";
};